import React, { useEffect, useCallback, useState } from "react";
import { Link } from "react-router-dom";
import {
    Form,
    Modal,
    Typography,
} from "antd";
import ShelfLifeAnalysisApi from "../../Apis/ShelfLifeAnalysisApi";
const { Title } = Typography;

function ShelfLifeData({ visible, onClose, Productctionid, source = "production" }) {
    const [formAdd] = Form.useForm();
    const [Products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    const getProducts = useCallback(() => {
        if (!Productctionid) return;
        
        setLoading(true);
        
        // Check the source to determine which API to call
        if (source === "product") {
            // Call product API for shelf life analysis
            ShelfLifeAnalysisApi.ListshelfLifeAnalysisProduct(Productctionid)
                .then((response) => {
                    setProducts(response?.payload || []);
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setProducts([]);
                    setLoading(false);
                });
        } else {
            // Call production API for shelf life analysis (default)
            ShelfLifeAnalysisApi.ListshelfLifeAnalysisProduction(Productctionid)
                .then((response) => {
                    setProducts(response?.payload || []);
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setProducts([]);
                    setLoading(false);
                });
        }
    }, [Productctionid, source]);

    // Call API when modal becomes visible OR when Productctionid changes
    useEffect(() => {
        if (visible && Productctionid) {
            getProducts();
        } else if (!visible) {
            // Reset products when modal closes
            setProducts([]);
        }
    }, [visible, Productctionid, getProducts]);

    function formatDate(date) {
        if (!date) return "N/A";
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString(
            "en-US",
            options
        );

        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }

    const handleCancel = () => {
        formAdd.resetFields();
        onClose();
    };

    return (
        <>
            <Modal
                footer={[]}
                width={700}
                open={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Shelf Life Analysis
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                >
                    <>
                        <div className="dateFilterTable">
                            {loading ? (
                                <div style={{ textAlign: "center", padding: "40px" }}>
                                    <div className="spinner"></div>
                                    <p>Loading shelf life data...</p>
                                </div>
                            ) : (
                                <table className="table users-table">
                                    <thead>
                                        <tr style={{ verticalAlign: 'top' }}>
                                            <th>Shelf Life Analysis Date</th>
                                            <th>Renewal Date</th>
                                            <th>File</th>
                                        </tr>
                                    </thead>
                                    <tbody className={Products?.length > 6 ? 'tableScroll' : ''}>
                                        {Products.map((item, index) => (
                                            <tr style={{ cursor: 'pointer' }} key={index}>
                                                <td className="CleanTable px-2 text-start PnameClass" style={{ width: '10%', textAlign: 'start' }}>
                                                    {formatDate(item?.shelfLifeAnalysisDate)}
                                                </td>
                                                <td style={{ width: '10%', textAlign: 'start' }} className="CleanTable text-start PnameClass">
                                                    {formatDate(item?.renewalDate)}
                                                </td>
                                                <td style={{ width: '10%', textAlign: 'start' }} className="CleanTable text-start PnameClass">
                                                    {item?.shelfLifeAnalysisResourceList && item?.shelfLifeAnalysisResourceList.length > 0 ? (
                                                        <a href={item?.shelfLifeAnalysisResourceList[0]?.fileDownloadUri} target="_blank" rel="noopener noreferrer">
                                                            Download
                                                        </a>
                                                    ) : (
                                                        "No file"
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                        {Products?.length === 0 && (
                                            <tr className="text-center EmptyTable">
                                                <td colSpan={3} className="text-center">
                                                    <img
                                                        src="/assest/Images/emptyIcon.svg"
                                                        className="logo-png mt-3"
                                                        style={{ width: "10%" }}
                                                        alt="No data"
                                                    />
                                                    <p>No shelf life analysis data available</p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default ShelfLifeData;